import { createAxiosApi } from "@/shared/axios/axios";
import { getAxiosErrorMessage } from "@/shared/axios/axiosError";

const api = createAxiosApi();

export type MeNotificationDto = {
    id: string;
    category: string;
    kind: string;
    title: string;
    body: string;
    readAt: string | null;
    payload: unknown;
    createdAt: string;
};

export type MeNotificationsListResponse = {
    total: number;
    unread: number;
    items: MeNotificationDto[];
};

async function wrap<T>(fn: () => Promise<{ data: T }>): Promise<T> {
    try {
        const res = await fn();
        return res.data;
    } catch (e) {
        throw new Error(getAxiosErrorMessage(e));
    }
}

export async function meNotificationsListApi(params?: {
    skip?: number;
    take?: number;
    category?: string | null;
}): Promise<MeNotificationsListResponse> {
    const q = new URLSearchParams();
    if (params?.skip != null) q.set("skip", String(params.skip));
    if (params?.take != null) q.set("take", String(params.take));
    const cat = params?.category?.trim();
    if (cat && cat !== "all") q.set("category", cat);
    const qs = q.toString();
    return wrap(() =>
        api<MeNotificationsListResponse>({
            type: "get",
            url: qs ? `/me/notifications?${qs}` : "/me/notifications",
        }),
    );
}

export async function meNotificationsUnreadCountApi(): Promise<{ count: number }> {
    return wrap(() => api<{ count: number }>({ type: "get", url: "/me/notifications/unread-count" }));
}

export async function meNotificationsMarkReadApi(body: { ids?: string[]; all?: boolean }): Promise<{ updated: number }> {
    return wrap(() => api<{ updated: number }>({ type: "patch", url: "/me/notifications/read", body }));
}
